import { required, sameAs, email, helpers } from "@vuelidate/validators";
import { reactive, computed } from "vue";

const validations = computed(() => {
  return {
    firstname: { required },
    lastname: { required },
    email: {
      required: helpers.withMessage("rules.required", required),
      email: helpers.withMessage("rules.email", email),
    },
    email_confirmation: {
      required: helpers.withMessage("rules.required", required),
      sameAs: helpers.withMessage("rules.sameAsEmail", sameAs(state.email)),
    },
    text: { required },
  };
});

const state = reactive({
  firstname: "",
  lastname: "",
  email: "",
  email_confirmation: "",
  text: "",
});

export { validations, state };
